import { render, staticRenderFns } from "./UnderDev.vue?vue&type=template&id=13bf30fa&scoped=true"
import script from "./UnderDev.vue?vue&type=script&lang=js"
export * from "./UnderDev.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bf30fa",
  null
  
)

export default component.exports